<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm' }} phiếu chuyển mục đích sử dụng</h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/usage-change')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div v-if="$route.name === 'updateUsageChange'" class="form-group row">
                <label class="col-sm-3 col-form-label">Chọn vùng </label>
                <div class="col-sm-9">
                  {{ dataRequest.regionName }}
                </div>
              </div>
              <ValidationProvider
                rules="required"
                vid="regionId"
                name="Chọn vùng"
                v-if="$route.name === 'createUsageChange'"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Chọn vùng<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      :disabled="!!dataRequest.id"
                      v-model="dataRequest.regionId"
                      :options="optionRegion"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div v-if="$route.name === 'updateUsageChange'" class="form-group row">
                <label class="col-sm-3 col-form-label">Lý do </label>
                <div class="col-sm-9">
                  {{ dataRequest.reasonUsageChange | transformData(Config.reasonUsageChange) }}
                </div>
              </div>
              <ValidationProvider
                rules="required"
                vid="cityCode"
                name="Lý do"
                v-if="$route.name === 'createUsageChange'"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-3 col-form-label">
                    Lý do <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.reason" :options="Config.reasonUsageChange" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Ghi chú</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
      <div class="p-0 pt-2 card mb-2 ml-2" v-if="dataRequest.regionId && dataRequest.reason">
        <div
          class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
        >
          <h1 class="mb-1 form-inner-heading">Danh sách thiết bị điều chuyển</h1>
          <div class="float-right btn-group">
            <!-- <button
              type="button"
              @click="exportTemplateUsageChange"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-download"></i> Tải file mẫu
            </button>
            <button
              type="button"
              @click="$refs.uploadFileExcel.click()"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-upload"></i> import file
            </button> -->
            <button
              type="button"
              @click="showAddDevice"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bxs-plus-circle"></i> Chọn thiết bị
            </button>
            <input
              style="display: none"
              ref="uploadFileExcel"
              @change="uploadFileExcel"
              type="file"
            />
          </div>
        </div>
        <div class="tab-content">
          <div
            class="table-responsive b-table-sticky-header"
            style="overflow: auto; max-height: 70vh"
          >
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr class="text-center">
                  <th class="text-left">Tên loại thiết bị</th>
                  <th>Số lượng</th>
                  <th>Mã Serial</th>
                  <th>DVT</th>
                  <th>Tình trạng</th>
                  <th>Ghi chú</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="table-row text-center"
                  v-for="(device, index) in dataRequest.devices"
                  :key="`device${index}`"
                >
                  <td class="text-left">{{ device.text ? device.text : device.categoryName }}</td>
                  <td>{{ device.quantity ? device.quantity : '1' }}</td>
                  <td>{{ device.serial }}</td>
                  <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                  <td>
                    <span class="badge" :class="[device.type || '']">
                      {{ device.type | transformData(Config.stateDevices) }}
                    </span>
                  </td>
                  <td>
                    <ValidationProvider rules="minMaxName_4" :vid="device.id" name="Ghi chú">
                      <template slot-scope="{ errors }">
                        <input
                          v-model.trim="device.noteExport"
                          type="text"
                          class="form-control"
                          placeholder="Ghi chú"
                        />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </template>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-button type="button" size="md" variant="danger" @click="deleteDevice(index)">
                      Xoá
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <b-modal
      id="modal-noti"
      centered
      v-model="modalChooseDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>Chọn thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <form @submit.prevent="filterDevice" class="box-search">
        <div class="form-group">
          <Select2 placeholder="Loại thiết bị" v-model="searchDevice.id" :options="deviceCatData" />
        </div>
        <div class="form-group">
          <input
            v-model.trim="searchDevice.serial"
            type="text"
            class="form-control"
            placeholder="Mã serial"
          />
        </div>
        <div class="form-group form-group-action d-flex" style="gap: 5px">
          <button type="button" class="font-medium btn btn-outline-secondary" @click="filterDevice">
            Lọc
          </button>
          <button
            type="buton"
            @click="unFilterDevice"
            class="font-medium btn btn-outline-secondary"
          >
            Bỏ lọc
          </button>
        </div>
      </form>
      <div class="table-responsive b-table-sticky-header">
        <div style="max-height: 400px; overflow: auto">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr class="text-center">
                <th>
                  <!-- <input type="checkbox" v-model="selectAllDevice" /> -->
                </th>
                <th>Loại thiết bị</th>
                <th>Mã Serial</th>
                <th>DVT</th>
                <th>Tình trạng</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row text-center"
                v-for="(device, index) in dataMaterial"
                :key="`dataMaterial${index}`"
              >
                <td>
                  <input id="checkbox" type="checkbox" v-model="selectedDevice" :value="device" />
                </td>
                <td class="text-left">{{ device.text }}</td>
                <td>{{ device.serial }}</td>
                <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                <td>
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination-bottom">
            <b-pagination
              v-model="search.page"
              :total-rows="pagination.total"
              :per-page="search.limit"
              class="fl-right mr-2"
            ></b-pagination>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevice" size="md" variant="primary"> Thêm </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  export default {
    name: 'usage-change-request',
    data() {
      return {
        Config,
        dataRequest: {
          devices: [],
        },
        showLoading: false,
        regionId: '',
        modalChooseDevice: false,
        deviceCatData: [],
        searchDevice: {},
        dataMaterial: [],
        selectedDevice: [],
        optionRegion: [],
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    components: {},
    created() {
      this.fetchCatDevice()
      this.getListRegion()
      if (this.$route.params.id) {
        this.fetchData()
      }
    },
    watch: {
      'search.page': function () {
        this.fetchDeviceByInventory()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      selectAllDevice: {
        get: function () {
          return this.dataMaterial ? this.selectedDevice.length === this.dataMaterial.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedDevice = cloneDeep(this.dataMaterial)
          } else this.selectedDevice = []
        },
      },
    },
    methods: {
      async submitRequest() {
        if (this.dataRequest.devices.length === 0) {
          this.showFailMx('Vui lòng thêm thiết bị')
          return
        }
        const params = this.preareDataAdd()
        try {
          this.showLoading = true
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            const response = await DeviceService.updateUsageChange(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật phiếu chuyển mục đích sử dụng thành công').then(() =>
                this.$router.push('/usage-change')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await DeviceService.createUsageChange(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới phiếu chuyển mục đích sử dụng thành công').then(() =>
                this.$router.push('/usage-change')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      preareDataAdd() {
        const deviceIds = this.dataRequest.devices.map(item => {
          return item.id
        })
        const dataPreare = {
          deviceIds,
          regionId: this.dataRequest.regionId,
          reason: this.dataRequest.reason,
          note: this.dataRequest.note,
        }
        return dataPreare
      },
      async fetchData() {
        const id = this.$route.params.id
        if (id) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.getDetailUsageChange({ id })
            if (responsive.code === 1000) {
              this.dataRequest = responsive.data
              this.dataRequest.reason = responsive.data.reasonUsageChange
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },

      showAddDevice() {
        this.fetchDeviceByInventory()
        this.$nextTick(() => {
          this.$bvModal.show('modal-noti')
        })
      },
      async fetchDeviceByInventory() {
        this.showLoading = true
        const response = await DeviceService.listDeviceByReason({
          regionId: this.dataRequest.regionId,
          reason: this.dataRequest.reason,
          kind: 'SERIAL',
          limit: this.search.limit,
          page: this.search.page,
        })
        this.deviceFilterData = response.data
        this.pagination.total = response.data.count
        this.dataMaterial = response.data.list.map(item => {
          return {
            id: item.id,
            text: item.categoryName,
            serial: item.serial,
            type: item.type,
            unit: item.unit,
          }
        })
        this.dataFilter = this.dataMaterial
        this.showLoading = false
      },
      async fetchCatDevice() {
        const response = await DeviceService.typeDeviceConfig()
        this.deviceCatData = response.data.map(({ id, name }) => {
          return { id: id, text: name }
        })
      },
      unFilterDevice() {
        this.searchDevice = {}
        this.fetchDeviceByInventory()
      },
      async filterDevice() {
        // const deviceData = this.dataFilter.filter(s => {
        //   const rules = []
        //   if (this.searchDevice.serial) {
        //     rules.push(
        //       s.serial.toLowerCase().indexOf(this.searchDevice.serial.toLowerCase()) > -1
        //     )
        //   }
        //   if (this.searchDevice.text) {
        //     rules.push(s.text === this.searchDevice.text)
        //   }
        //   return !rules.includes(false)
        // })
        const response = await DeviceService.listDeviceByReason({
          kind: 'SERIAL',
          limit: this.search.limit,
          page: this.search.page,
          serial: this.searchDevice.serial,
          categoryId: this.searchDevice.id,
          regionId: this.dataRequest.regionId,
          reason: this.dataRequest.reason,
        })

        this.deviceFilterData = response.data
        this.pagination.total = response.data.count
        if (!response.data.list) {
          this.dataMaterial = []
          this.dataFilter = []
        }
        if (response.data.list && response.data.list.length > 0) {
          this.dataMaterial = response.data.list.map(item => {
            return {
              id: item.id,
              text: item.categoryName,
              serial: item.serial,
              type: item.type,
              unit: item.unit,
            }
          })
          this.dataFilter = this.dataMaterial
        }

        // this.dataMaterial = deviceData
      },
      async requestDevice() {
        const arr = [...this.selectedDevice, ...this.dataRequest.devices]
        this.dataRequest.devices = this.getUnique(arr, 'id')
        this.modalChooseDevice = false
        this.selectedDevice = []
      },
      getUnique(arr, comp) {
        const unique = arr
          .map(e => e[comp])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => arr[e])
          .map(e => arr[e])
        return unique
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataRequest.devices.splice(index, 1)
            }
          })
      },
      async getListRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async exportTemplateUsageChange() {
        try {
          this.showLoading = true
          await DeviceService.exportTemplateUsageChange()
        } finally {
          this.showLoading = false
        }
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        console.log(file.target.files[0])
        formdata.append('file', file.target.files[0])
        formdata.append('regionId', this.dataRequest.regionId)
        try {
          this.showLoading = true
          const res = await DeviceService.importDeviceExcelUsageChange(formdata)
          if (res.code === 1000) {
            const arr = [...res.data.correctList, ...this.dataRequest.devices]
            this.dataRequest.devices = this.getUnique(arr, 'id')
            this.showMsgOk(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showFailMx(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showFailMx(res.res[0].message)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          console.log(e)
          this.showFailMx(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.correctList.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.errorList.length),
            ' bản ghi',
          ]),
          data.errorList.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.errorList),
                },
              },
              'Tải bản ghi thất bại'
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await DeviceService.exportDeviceExcelUsageChange(reqs)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .addDevice {
    display: flex;
    justify-content: space-between;
  }
  .tableDevice {
    min-height: 145px;
  }
</style>
